import { useEffect } from "react";
import PollingModeIndicator from "@/shared/components/PollingModeIndicator";
import { useIsFirehosePollingMode } from "./useIsFirehosePollingMode";
import type { WidgetHeaderOptions } from "@/widget-components/types";

const ACTION_KEY = "00-polling-mode";

/**
 * Pushes a Polling indicator into the widget header whenever the firehose SSE
 * client has fallen back to polling. Mirrors the inline pattern used by
 * NewsquawkHeadlines so visual placement is consistent across feeds.
 */
export function useFirehosePollingHeader(
  headerOptions: WidgetHeaderOptions | undefined
) {
  const isPolling = useIsFirehosePollingMode();

  useEffect(() => {
    if (!headerOptions) return;
    if (isPolling) {
      headerOptions.pushAction(<PollingModeIndicator key={ACTION_KEY} />);
    } else {
      headerOptions.setActions((prev) =>
        prev.filter((a) => a.key !== ACTION_KEY)
      );
    }
  }, [isPolling, headerOptions]);
}
